import { render, staticRenderFns } from "./assesment.vue?vue&type=template&id=febf2e0a"
import script from "./assesment.vue?vue&type=script&lang=js"
export * from "./assesment.vue?vue&type=script&lang=js"
import style0 from "./assesment.vue?vue&type=style&index=0&id=febf2e0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports